import { render, staticRenderFns } from "./addInfo.vue?vue&type=template&id=4430aeb2&scoped=true&"
import script from "./addInfo.vue?vue&type=script&lang=js&"
export * from "./addInfo.vue?vue&type=script&lang=js&"
import style0 from "./addInfo.vue?vue&type=style&index=0&id=4430aeb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430aeb2",
  null
  
)

export default component.exports